function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { Spin } from '@nackle/paper';
import RosterService from '../../services/roster';
export default class HierarchyLabel extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      loading: false,
      hierarchyId: null,
      hierarchyNodeId: null,
      hierarchyNode: null
    });
    _defineProperty(this, "loadHierarchyNode", async (hierarchyId, hierarchyNodeId) => {
      const {
        auth
      } = this.props;
      this.setState({
        loading: true
      });
      try {
        const rosterService = new RosterService(auth.state);
        if (!hierarchyId) {
          hierarchyId = await rosterService.findHierarchyIdForHierarchyNode(hierarchyNodeId);
        }
        const hierarchyNode = await rosterService.getHierarchyNode(hierarchyId, hierarchyNodeId);
        this.setState({
          hierarchyNode,
          loading: false
        });
      } catch (error) {
        console.error(error);
        this.setState({
          loading: false,
          hierarchyNode: {
            id: hierarchyNodeId,
            name: '¯\\_(ツ)_/¯'
          }
        });
      }
    });
  }
  static getDerivedStateFromProps(props, state) {
    if (props.hierarchyId === state.hierarchyId && props.hierarchyNodeId === state.hierarchyNodeId) {
      return null;
    }
    return {
      hierarchyId: props.hierarchyId,
      hierarchyNodeId: props.hierarchyNodeId,
      hierarchyNode: null,
      hierarchyNodes: []
    };
  }
  componentDidMount() {
    const {
      hierarchyNodeId,
      hierarchyNode,
      loading
    } = this.state;
    if (!loading && hierarchyNodeId && hierarchyNodeId !== (hierarchyNode === null || hierarchyNode === void 0 ? void 0 : hierarchyNode.id)) {
      this.loadHierarchyNode(this.state.hierarchyId, this.state.hierarchyNodeId);
    }
  }
  componentDidUpdate() {
    const {
      hierarchyNodeId,
      hierarchyNode,
      loading
    } = this.state;
    if (!loading && hierarchyNodeId && hierarchyNodeId !== (hierarchyNode === null || hierarchyNode === void 0 ? void 0 : hierarchyNode.id)) {
      this.loadHierarchyNode(this.state.hierarchyId, this.state.hierarchyNodeId);
    }
  }
  render() {
    const {
      hierarchyNodeId,
      ...props
    } = this.props;
    const {
      loading,
      hierarchyNode
    } = this.state;
    return /*#__PURE__*/React.createElement("span", props, hierarchyNodeId && (hierarchyNode === null || hierarchyNode === void 0 ? void 0 : hierarchyNode.id) === hierarchyNodeId ? /*#__PURE__*/React.createElement("span", null, hierarchyNode.name) : loading ? /*#__PURE__*/React.createElement(Spin, {
      size: "small"
    }) : /*#__PURE__*/React.createElement("span", null));
  }
}
//# sourceMappingURL=hierarchy-node-label.js.map